
import React, { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';

import {validateForSpecialCharacter,validateForUpperCase,validateForLowerCase,validateForNumber} from '../../../../../utils'

import styles from './index.module.scss';

interface IpasswordValidatorProps {
	password:string,
}

const PasswordValidator: React.FC<IpasswordValidatorProps>  = ({password}) => {
	const { t } = useTranslation();
	const [valid1,setLengthValidator]=useState<boolean>(false)
	const [valid2,setMinOneLoweCaseValidator]=useState<boolean>(false)
	const [valid3,setMinOneUpperCaseValidator]=useState<boolean>(false)
	const [valid4,setMinOneSpecialCharacterValidator]=useState<boolean>(false)
	const [valid5,setMinOneNumberValidator]=useState<boolean>(false)

	useEffect(() => {
		setMinOneSpecialCharacterValidator(validateForSpecialCharacter(password))
    	setMinOneUpperCaseValidator(validateForUpperCase(password))
		setMinOneLoweCaseValidator(validateForLowerCase(password))
		setLengthValidator(password.length>=12)
		setMinOneNumberValidator(validateForNumber(password))
	}, [password]);

	return (
		<div className={styles.passContainer}>
			<h1 className={styles.passHead}>{t('KLR00445')}</h1>
			<div>
			<div className={styles.passText}>
				<span
					className={valid1 ? styles.greenDot : styles.redDot}
				/>
				{t('KLR00446')}
			</div>
			<div className={styles.passText}>
				<span
					className={valid3 ? styles.greenDot : styles.redDot}
				/>
				{t('minimumOneUppercase')}
			</div>
			<div className={styles.passText}>
				<span
					className={valid2 ? styles.greenDot : styles.redDot}
				/>
				{t('minimumOneLowercase')}
			</div>
			<div className={styles.passText}>
				<span
					className={valid5 ? styles.greenDot : styles.redDot}
				/>
				{t('minimumOneNumber')}
			</div>
			<div className={styles.passText}>
				<span
					className={valid4 ? styles.greenDot : styles.redDot}
				/>
				{t('minimumOneSpecialCharacter')}
			</div>
			</div>
		</div>
	);
};

export default PasswordValidator;
